module.exports = __webpack_public_path__ + "58a27772da4ae65d43d0852e7e12adcf.svg";